module.exports = __webpack_public_path__ + "img/1920x793px.2a7c3054.jpg";